export const resize = {
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
    
    mounted() {
        this.$nextTick( function() {
            window.addEventListener('resize', this.handleResize)
        })
        this.handleResize()
    },

    methods: {
        isTabletPortrait: () => window.matchMedia(`
            (min-device-width: 768px) 
            and (max-device-width: 1112px)
            and (orientation: portrait)
        `).matches,
        handleResize() {
            const { innerWidth: width, innerHeight: height } = window 
            
            const orientation = this.isTabletPortrait()
                ? 'portrait' 
                : 'landscape'

            this.$store.dispatch('browser/setupBrowser', {
                width,
                height,
                orientation,
            })
        },
    },
}